import './maintenance.css';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import Load from './tabs/load';
import Country from './tabs/country';
import Port from './tabs/port';
import Currency from './tabs/currency';

export const RefDataContext = React.createContext();

const RefData = () => {
  const [onAddNew, setOnAddNew] = useState(() => () => {});
  const [activeTab, setActiveTab] = useState('load');
  const addHandlers = useRef({});

  const registerAddHandler = useCallback(
    (tabKey, handler) => {
      addHandlers.current[tabKey] = handler;
      if (tabKey === activeTab) {
        setOnAddNew(() => (typeof handler === 'function' ? handler : () => {}));
      }
    },
    [activeTab]
  );

  const refDataState = {
    registerAddHandler,
    // legacy alias
    setOnAddNew: (handler) => registerAddHandler(activeTab, handler),
  };

  useEffect(() => {
    const handler = addHandlers.current[activeTab];
    setOnAddNew(() => (typeof handler === 'function' ? handler : () => {}));
  }, [activeTab]);

  return (
    <RefDataContext.Provider value={refDataState}>
      <Container fluid="2xl" className=" mt-5 semi-fluid-container medium-middle-container ">
        <section className="floating-box-userProfile pb-2 px-4">
          <div className="floating-box-header-userProfile ps-0 ms-0">
            <span>CABIE Codelists</span>
            <span className="flex-grow-1"></span>
            <button
              className="blue-button-teams green-btn"
              onClick={() => {
                if (typeof onAddNew === 'function') onAddNew();
              }}
            >
              Add
            </button>
          </div>

          <Tabs
            defaultActiveKey={'load'}
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            mountOnEnter={true}
            unmountOnExit={true}
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="load" title="Package Type">
              <Load />
            </Tab>
            <Tab eventKey="port" title="Port Codes">
              <Port />
            </Tab>
            <Tab eventKey="currency" title="Currency">
              <Currency />
            </Tab>
            <Tab eventKey="country" title="Origin">
              <Country />
            </Tab>
            {/* <Tab eventKey="commodity-codes" title="Commodity Codes">
              <CommodityCodes />
            </Tab>
            <Tab eventKey="movement" title="Movement Type">
              <MovementType />
            </Tab>
            <Tab eventKey="ports" title="Ports">
              <Ports />
            </Tab>
            <Tab eventKey="ship-status" title="Ship Status">
              <ShipStatus />
            </Tab>
            <Tab eventKey="incoterm" title="Incoterm">
              <Incoterm />
            </Tab> */}
          </Tabs>
        </section>
      </Container>
    </RefDataContext.Provider>
  );
};

export default RefData;
